var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoLogin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 66.015,
    viewBox: "0 0 200 66.015",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1281",
    "data-name": "Group 1281",
    transform: "translate(-1100.722 -734)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_422",
    "data-name": "Path 422",
    d: "M11.525,23.231h9.125v5.642H11.525V52.221H4.2V35.242a6.723,6.723,0,0,1,6.225-6.37H0V23.231H4.2V21.512c0-7.382,4.861-11.884,11.644-11.884a14.1,14.1,0,0,1,6.6,1.5l-2.221,5.822a6.443,6.443,0,0,0-3.541-1.2c-3.3,0-5.162,2.222-5.162,5.642Z",
    transform: "translate(1100.722 734.08)",
    fill: "#14305c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_423",
    "data-name": "Path 423",
    d: "M44.3,37.712c0-5.041-3.18-8.884-7.683-8.884s-7.683,3.842-7.683,8.884c0,4.982,3.18,8.764,7.683,8.764S44.3,42.694,44.3,37.712m7.143,0c0,8.524-5.883,14.466-14.826,14.466-8.883,0-14.825-5.942-14.825-14.466s5.942-14.585,14.825-14.585c8.943,0,14.826,6.062,14.826,14.585",
    transform: "translate(1100.889 734.184)",
    fill: "#14305c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3243",
    "data-name": "Rectangle 3243",
    width: 7.262,
    height: 42.737,
    transform: "translate(1157.534 743.708)",
    fill: "#14305c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424",
    "data-name": "Path 424",
    d: "M76.287,35.25H89.372c-.059-3.72-2.4-6.422-6.123-6.422-3.661,0-6.3,2.462-6.962,6.422m16.026,7.864,3.721,4.022c-2.16,2.82-6.3,5.041-12,5.041-9.423,0-15.125-5.941-15.125-14.465s5.642-14.586,14.344-14.586c8.283,0,13.025,5.7,13.025,13.326a12.746,12.746,0,0,1-.3,2.941H76.287c.66,4.2,3.541,7.083,8.523,7.083a9.226,9.226,0,0,0,7.5-3.362",
    transform: "translate(1101.251 734.184)",
    fill: "#14305c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_425",
    "data-name": "Path 425",
    d: "M98.547,59.65c3.241,0,4.5-1.981,4.5-5.4l-.3-31.12h7.323l.3,30.64c0,7.383-3.361,12.065-10.924,12.065-4.143,0-5.882-1.8-5.882-1.8l2.1-5.1a5.544,5.544,0,0,0,2.881.721",
    transform: "translate(1100.655 734.184)",
    fill: "#14305c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_426",
    "data-name": "Path 426",
    d: "M132.894,41.855v-2.4h-.481c-7.684.12-10.924,1.321-10.924,4.142,0,1.921,1.561,3,4.381,3,4.441,0,7.024-2.341,7.024-4.741M143.038,51.7a15.982,15.982,0,0,1-3.6.42c-3.661,0-5.7-1.441-6.184-4.5-.839,1.619-3.24,4.561-9.3,4.561-6.182,0-9.6-3.12-9.6-7.8,0-6.783,6.9-8.764,18.067-8.944h.481V34.051c0-3.181-1.921-5.282-5.7-5.282-3.484,0-5.4,1.381-5.4,3.721a2.936,2.936,0,0,0,.241,1.141l-6.481,1.08a9.644,9.644,0,0,1-.362-2.641c0-5.342,4.622-8.943,12.245-8.943,8.1,0,12.605,4.2,12.605,11.1V44.2c0,1.44.481,1.921,1.681,1.921A5.26,5.26,0,0,0,142.738,46Z",
    transform: "translate(1101.599 734.184)",
    fill: "#14305c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1282",
    "data-name": "Group 1282",
    transform: "translate(1197.415 734)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_427",
    "data-name": "Path 427",
    d: "M105.657,5.713a.961.961,0,0,1-.961-.961V.961a.961.961,0,1,1,1.922,0V4.752a.961.961,0,0,1-.961.961",
    transform: "translate(-96.514 0)",
    fill: "#11d88b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_428",
    "data-name": "Path 428",
    d: "M109.157,7.946a.961.961,0,0,1-.679-1.64l2.672-2.672a.961.961,0,0,1,1.359,1.359l-2.672,2.672a.958.958,0,0,1-.679.282",
    transform: "translate(-96.651 -0.131)",
    fill: "#11d88b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_429",
    "data-name": "Path 429",
    d: "M111.749,11.555H110.9a.961.961,0,0,1,0-1.922h.848a.961.961,0,1,1,0,1.922",
    transform: "translate(-96.719 -0.377)",
    fill: "#11d88b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_430",
    "data-name": "Path 430",
    d: "M112.618,18.515a.958.958,0,0,1-.679-.282L107.9,14.2a.961.961,0,1,1,1.359-1.359l4.035,4.035a.961.961,0,0,1-.679,1.64",
    transform: "translate(-96.628 -0.491)",
    fill: "#11d88b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_431",
    "data-name": "Path 431",
    d: "M105.657,17.714a.961.961,0,0,1-.961-.961v-1.2a.961.961,0,1,1,1.922,0v1.2a.961.961,0,0,1-.961.961",
    transform: "translate(-96.514 -0.571)",
    fill: "#11d88b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_432",
    "data-name": "Path 432",
    d: "M102.187,8.085a.958.958,0,0,1-.679-.282L99.05,5.344a.961.961,0,0,1,1.359-1.359l2.458,2.459a.961.961,0,0,1-.679,1.64",
    transform: "translate(-96.282 -0.145)",
    fill: "#11d88b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_433",
    "data-name": "Path 433",
    d: "M100.332,11.555h-3.19a.961.961,0,1,1,0-1.922h3.19a.961.961,0,1,1,0,1.922",
    transform: "translate(-96.181 -0.377)",
    fill: "#11d88b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_434",
    "data-name": "Path 434",
    d: "M97.691,19.317a.961.961,0,0,1-.679-1.64l5.014-5.014a.961.961,0,1,1,1.359,1.359L98.37,19.035a.958.958,0,0,1-.679.282",
    transform: "translate(-96.203 -0.484)",
    fill: "#11d88b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLogin);
export default __webpack_public_path__ + "static/media/LogoLogin.06949162514782937d3026ce1995f83e.svg";
export { ForwardRef as ReactComponent };